export const CheckSquare = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 5H7C5.89543 5 5 5.89543 5 7V25C5 26.1046 5.89543 27 7 27H25C26.1046 27 27 26.1046 27 25V16" stroke="currentColor" stroke-width="2"/>
  <path d="M12 14.2681L16 18.2681L28.2681 6" stroke="currentColor" stroke-width="2"/>
</svg>`;
